/**
 * MobileTopBar — iter1089 — sticky mobile top bar with a back arrow.
 *
 * Използвайте върху страници, които разчитаха само на `MobileBottomNav`
 * (Dashboard, HealthIntelligence, Profile, Diary), но липсваше обратно
 * навигиране от sub-екрани.
 *
 * Скрит на десктоп (`md:hidden`), за да не дублира `SubpageNav`.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";

export function MobileTopBar({ title, fallbackTo = "/dashboard", right = null, testid = "mobile-topbar" }) {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const handleBack = React.useCallback(() => {
    const cameFromApp = typeof window !== "undefined"
      && window.history
      && window.history.length > 1
      && (document.referrer === "" || document.referrer.includes(window.location.host));
    if (cameFromApp) {
      navigate(-1);
    } else {
      navigate(fallbackTo);
    }
  }, [navigate, fallbackTo]);

  return (
    <div
      data-testid={testid}
      className={`md:hidden sticky top-0 z-40 backdrop-blur-xl border-b flex items-center justify-between px-3 py-2.5 ${
        isDark
          ? "bg-[hsl(223,47%,6%)]/95 border-[hsl(223,47%,12%)]"
          : "bg-white/95 border-slate-100"
      }`}
    >
      <button
        type="button"
        onClick={handleBack}
        data-testid={`${testid}-back`}
        aria-label="Назад"
        className={`inline-flex items-center gap-1.5 min-h-[40px] px-2 -ml-1 rounded-lg text-sm font-medium transition-colors ${
          isDark ? "text-slate-300 hover:bg-white/5" : "text-slate-700 hover:bg-slate-100"
        }`}
      >
        <ArrowLeft className="w-5 h-5" />
        <span>Назад</span>
      </button>
      {title ? (
        <div
          data-testid={`${testid}-title`}
          className={`text-sm font-semibold truncate mx-2 ${isDark ? "text-slate-200" : "text-slate-800"}`}
        >
          {title}
        </div>
      ) : <span />}
      <div className="min-w-[40px] flex justify-end">{right}</div>
    </div>
  );
}

export default MobileTopBar;
